module.exports = __webpack_public_path__ + "static/media/Bittrex.a301b9b0.svg";